import Model from "./base/model";

class AdditionalService extends Model{
  resourceName() {
    return "additional_services";
  }

  fields() {
    return {
      name: "",
      nf: "",
    }
  }
}

export default new AdditionalService();
